// src/hooks/useStoreDetails.js
import { useState, useEffect } from "react";
import axiosInstance from "../utils/axiosInstance";

export const useStoreDetails = () => {
  const [storeName, setStoreName] = useState(() => {
    try {
      const saved = sessionStorage.getItem("wixStoreDetails");
      return saved ? JSON.parse(saved).storeName || "" : "";
    } catch { return ""; }
  });

  useEffect(() => {
    if (storeName) return;
    axiosInstance.get("/wix/oauth/getStoreDetails")
      .then(res => {
        const d = res.data?.data;
        if (d) {
          sessionStorage.setItem("wixStoreDetails", JSON.stringify(d));
          setStoreName(d.storeName || "");
        }
      })
      .catch(console.error);
  }, []);

  return { storeName };
};
